// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-ArticleList----index-module---list---b1YO5","item":"src-components-ArticleList----index-module---item---c0aYS","text":"src-components-ArticleList----index-module---text---3R_Uk","image":"src-components-ArticleList----index-module---image---3EGU6","title":"src-components-ArticleList----index-module---title---3noyz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArticleList/index.module.css
// module id = 320
// module chunks = 35783957827783